module.exports = __webpack_public_path__ + "static/media/inovacao-gestao.704ab8d5.svg";